import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AdminLayout from "../Components/Layouts/AdminLayout/AdminLayout";
import Home from "../Pages/Home";

// Admin Pages Add
import AdminDashboard from "../Pages/Admin/Dashboard";
import AdminEvents from "../Pages/Admin/Events";
import AdminOrganiser from "../Pages/Admin/Organiser";
// Claude: re-enabled AdminSubscriptions as standalone page 19-02-2026
import AdminSubscriptions from "../Pages/Admin/SellerSubscriptions";
import AdminBuyerSubscriptions from "../Pages/Admin/BuyerSubscriptions"; // Claude: buyer subscription plans 11-Apr-2026
import AdminIndustry from "../Pages/Admin/Industry"; // Claude: industry tree admin page 27-02-2026
import AdminDepartments from "../Pages/Admin/Departments"; // Claude: flat department list admin page 16-Apr-2026
import AdminIndustryStats from "../Pages/Admin/IndustryStats"; // Claude: industry stats page 13-03-2026
import AdminDepartmentStats from "../Pages/Admin/DepartmentStats"; // Claude: department stats page 18-04-2026
import AdminTagsList from "../Pages/Admin/TagsList"; // Claude: tags list page 04-05-2026
import AdminRewardPlans from "../Pages/Admin/RewardPlans"; // Claude: reward plans admin page 27-02-2026
import AdminSellers from "../Pages/Admin/Seller";
import SellerEditPage from "../Pages/Admin/SellerEditPage"; // Claude: add/edit seller as page 25-Apr-2026
import AdminBuyers from "../Pages/Admin/Buyer";
import BuyerEditPage from "../Pages/Admin/BuyerEditPage"; // Claude: add/edit buyer as page 25-Apr-2026
import BuyerRewards from "../Pages/Admin/BuyerRewards";
import AdminLogin from "../Pages/Admin/Login";
import AdminUploadReports from "../Pages/Admin/UploadReports"; // Claude: A1 — upload reports page 26-02-2026
import AdminStats from "../Pages/Admin/Stats"; // Claude: Stats admin page 27-02-2026
import AdminCompanies from "../Pages/Admin/Companies"; // Claude: Companies aggregated view 01-03-2026
import AdminUsers from "../Pages/Admin/AdminUsers"; // Claude: Admin Users page 02-03-2026
import AdminBuyerFAQ from "../Pages/Admin/BuyerFAQ"; // Claude: Buyer FAQ admin page 13-03-2026
import AdminSellerFAQ from "../Pages/Admin/SellerFAQ"; // Claude: Seller FAQ admin page 13-03-2026
import AdminAIKnowledgeBuyers from "../Pages/Admin/AIKnowledgeBuyers"; // Claude: AI KB Buyers admin page 15-03-2026
import AdminAIKnowledgeSellers from "../Pages/Admin/AIKnowledgeSellers"; // Claude: AI KB Sellers admin page 15-03-2026
import AdminAIKnowledgeCommon from "../Pages/Admin/AIKnowledgeCommon"; // Claude: AI KB Common admin page 25-03-2026
import AdminSellerFeedback from "../Pages/Admin/SellerFeedback"; // Claude: Seller Feedback admin page 26-03-2026
import AdminBuyerFeedback from "../Pages/Admin/BuyerFeedback"; // Claude: Buyer Feedback admin page 26-03-2026

// Common
import MobileLayout from "../Components/Layouts/MobileLayout/MobileLayout";
import Login from "../Pages/Common/Login";
import ResetPassword from "../Pages/Common/ResetPassword";
import Relevance from "../Pages/Common/Relevance";
import Notifications from "../Components/Common/NoNotifications";
import Profile from "../Pages/Common/Profile";
import ForgotPassword from "../Pages/Common/ForgotPassword";
import CreateMeeting from "../Pages/Common/CreateMeeting";
//import Meeting from "../Pages/Common/Meeting";//Vishy 2025-02-18 build warning not used, so removed

// Organizer
import Account from "../Pages/Organizer/Account";
import OrganizerLayout from "../Components/Layouts/OrganizerLayout/OrganizerLayout";
import OrganizerHome from "../Pages/Organizer/Home";
import Company from "../Pages/Organizer/Company";
import Chat from "../Pages/Organizer/Chat";
import Notification from "../Pages/Common/Notification";

//Seller
import SellerLayout from "../Components/Layouts/SellerLayout/SellerLayout";
import SellerChat from "../Pages/Common/Chat";
import BuyersList from "../Pages/Seller/BuyersList";
import SellerCompany from "../Pages/Seller/Company";
import SellerAccount from "../Pages/Seller/Account";
import SellerCatalog from "../Pages/Seller/SellerCatalog";
import SellerAnnouncements from "../Pages/Seller/Announcements";
import SellerProfile from "../Pages/Seller/Profile";
import SellerAiChat from "../Pages/Seller/AiChat"; // Claude: Seller AI Chat page import 16-02-2026
import SellerDashboard from "../Pages/Seller/SellerDashboard";
import ProfileVisibility from "../Pages/Seller/ProfileVisibility"; // Claude: Profile Visibility page 10-03-2026

//Buyer
import BuyerLayout from "../Components/Layouts/BuyerLayout/BuyerLayout";
import BuyerChat from "../Pages/Common/Chat";
import BuyerHome from "../Pages/Buyer/SellersList";
import BuyerCompany from "../Pages/Buyer/Company";
import BuyerAccount from "../Pages/Buyer/Account";
import BuyerRFP from "../Pages/Buyer/RFP";
import Discover from "../Pages/Buyer/Discover"; // Claude: Discover page 31-03-2026
// Claude: BuyerRFXResponses removed — RFXResponses.tsx repurposed for discover matched sellers 31-03-2026
import SellerRFXList from "../Pages/Seller/RFXList";
import SellerRFXDetail from "../Pages/Seller/RFXDetail";
import Qrscan from "../Pages/Buyer/Qrscan";
import BuyerProfile from "../Pages/Buyer/Profile";
import BuyerDashboard from "../Pages/Buyer/BuyerDashboard";
import BuyerCatalog from "../Pages/Buyer/BuyerCatalog"; // Claude: buyer digital assets 25-02-2026
import BuyerSubscription from "../Pages/Buyer/Subscription"; // Claude: buyer subscription page 11-Apr-2026
import AiChat from "../Pages/Buyer/AiChat"; // Claude: AI Chat page import 16-02-2026
// Claude: N47 — Feeds reinstated as standalone route 26-03-2026
import BuyerFeeds from "../Pages/Buyer/Feeds";
// Claude: Discover import removed — merged into MyRFXs.tsx as Keyword Search tab 10-03-2026

import { useDispatch, useSelector } from "react-redux";
import { AuthAPI } from "../Apis/authAPI";
import actions from "../redux/Actions";
import { errorHandler } from "../Utils/handler";
import { useToastWrapper } from "../Wrapper/toastWrapper";
import MeetingList from "../Pages/Common/MeetingList";
import Rewards from "../Pages/Buyer/Rewards";
import RewardsStatement from "../Pages/Buyer/RewardsStatement";
//import RewardsRedeem from "../Pages/Buyer/RewardsRedeem";
import RedemptionVerification from "../Pages/Buyer/RedemptionVerification";
import Subscription from "../Pages/Seller/Subscription";
import SubscriptionPurchase from "../Pages/Seller/SubscriptionPurchase";
import SubscriptionStatement from "../Pages/Seller/SubscriptionStatement";
import SubscriptionCart from "../Pages/Seller/SubscriptionCart";
//import Calendar from "../Pages/Seller/Calendar";//Vishy 2025-02-18 build warning not used, so removed
import CreatePassword from "../Pages/Common/CreatePassword";
import Redemption from "../Pages/Buyer/Redemption";
import AdminForgotPassword from "Pages/Admin/ForgotPassword";
import NewUserRegistration from "../Pages/Common/NewUserRegistration"; // Claude: N25 — self-registration page 05-03-2026

type Props = {};

// Claude: route-to-title map for dynamic browser tab titles 23-02-2026
const PAGE_TITLES: Record<string, string> = {
  "/": "AFTR | Home",
  // Admin
  "/admin": "AFTR | Admin | Dashboard",
  "/admin/login": "AFTR | Admin | Login",
  "/admin/forgot-password": "AFTR | Admin | Forgot Password",
  "/admin/organizer": "AFTR | Admin | Organizers",
  "/admin/events": "AFTR | Admin | Events",
  "/admin/sellers": "AFTR | Admin | Sellers",
  "/admin/sellers/new": "AFTR | Admin | Add Seller",
  "/admin/buyers": "AFTR | Admin | Buyers",
  "/admin/buyers/new": "AFTR | Admin | Add Buyer",
  "/admin/seller-subscriptions": "AFTR | Admin | Seller Plans",
  "/admin/buyer-subscriptions": "AFTR | Admin | Buyer Plans", // Claude: buyer subscription plans 11-Apr-2026
  "/admin/industry": "AFTR | Admin | Industry",
  "/admin/departments": "AFTR | Admin | Departments", // Claude: 16-Apr-2026
  "/admin/industry-stats": "AFTR | Admin | Industry Stats",
  "/admin/department-stats": "AFTR | Admin | Department Stats", // Claude: 18-04-2026
  "/admin/tags-list": "AFTR | Admin | Tags List", // Claude: 04-05-2026
  "/admin/reward-plans": "AFTR | Admin | Reward Plans",
  "/admin/buyer-rewards": "AFTR | Admin | Buyer Rewards",
  "/admin/upload-reports": "AFTR | Admin | Upload Reports",
  "/admin/stats": "AFTR | Admin | Stats",
  "/admin/companies": "AFTR | Admin | Companies",
  "/admin/admin-users": "AFTR | Admin | Admin Users",
  "/admin/buyer-faq": "AFTR | Admin | Buyer FAQ",
  "/admin/seller-faq": "AFTR | Admin | Seller FAQ",
  "/admin/ai-knowledge-common": "AFTR | Admin | AI KB Common",
  "/admin/ai-knowledge-buyers": "AFTR | Admin | AI KB Buyers",
  "/admin/ai-knowledge-sellers": "AFTR | Admin | AI KB Sellers",
  "/admin/seller-feedback": "AFTR | Admin | Seller Feedback",
  "/admin/buyer-feedback": "AFTR | Admin | Buyer Feedback",
  // Common
  "/login": "AFTR | Sign In",
  "/register": "AFTR | Register",
  "/forgot-password": "AFTR | Forgot Password",
  "/reset-password": "AFTR | Reset Password",
  "/profile": "AFTR | Profile",
  "/meet": "AFTR | Create Meeting",
  "/notification": "AFTR | Notifications",
  "/relevance": "AFTR | Relevance",
  // Organizer
  "/organizer": "AFTR | Organizer Home",
  "/organizer/company": "AFTR | Company",
  "/organizer/chat": "AFTR | Chat",
  "/organizer/myaccount": "AFTR | My Account",
  "/organizer/notifications": "AFTR | Notifications",
  // Seller
  "/seller": "AFTR | Seller Dashboard",
  "/seller/ai": "AFTR | AI Assistant",
  "/seller/list": "AFTR | Browse Buyers",
  "/seller/calendar": "AFTR | Meetings",
  "/seller/profile": "AFTR | Profile",
  "/seller/visibility": "AFTR | Profile Visibility",
  "/seller/chat": "AFTR | Chat",
  "/seller/notifications": "AFTR | Notifications",
  "/seller/company": "AFTR | Company",
  "/seller/myaccount": "AFTR | My Account",
  "/seller/catalog": "AFTR | Catalog",
  "/seller/announcements": "AFTR | Announcements",
  "/seller/seller-subscriptions": "AFTR | Subscriptions",
  "/seller/seller-subscriptions-cart": "AFTR | Subscription Cart",
  "/seller/seller-subscriptions-purchase": "AFTR | Subscription Purchase",
  "/seller/seller-subscriptions-statements": "AFTR | Subscription Statements",
  "/seller/rfxs": "AFTR | Opportunities", // Claude: renamed 11-03-2026
  "/seller/rfx-detail": "AFTR | RFX Detail",
  // Buyer
  "/buyer": "AFTR | Buyer Dashboard",
  "/buyer/ai": "AFTR | AI Assistant",
  "/buyer/feeds": "AFTR | Feeds", // Claude: N47 26-03-2026
  "/buyer/list": "AFTR | Browse Sellers",
  "/buyer/calendar": "AFTR | Meetings",
  "/buyer/profile": "AFTR | Profile",
  "/buyer/chat": "AFTR | Chat",
  "/buyer/notifications": "AFTR | Notifications",
  "/buyer/company": "AFTR | Company",
  "/buyer/myaccount": "AFTR | My Account",
  "/buyer/rfp": "AFTR | RFP",
  "/buyer/scan": "AFTR | Scan QR",
  "/buyer/rewards": "AFTR | Rewards",
  "/buyer/rewards-statement": "AFTR | Rewards Statement",
  "/buyer/redemption-verification": "AFTR | Redemption Verification",
  // "/buyer/feeds" removed — Feeds merged into /buyer/rfxs Search tab 14-03-2026
  // "/buyer/discover" removed — Keyword Search now part of /buyer/rfxs 10-03-2026
  "/buyer/catalog": "AFTR | Digital Assets", // Claude: buyer digital assets 25-02-2026
  "/buyer/subscription": "AFTR | Subscription Plan", // Claude: buyer subscription page 11-Apr-2026
  "/buyer/rfxs": "AFTR | Search", // Claude: renamed 11-03-2026
  "/buyer/rfx-responses": "AFTR | RFX Responses",
};

const Router = (props: Props) => {
  const user = useSelector((state: any) => state.user);
  const location = useLocation();

  const { error } = useToastWrapper();

  const dispatch = useDispatch();

  const refreshToken = async (token: string) => {
    try {
      const res = await AuthAPI.patchRefreshToken(token);
      if (res.success) {
        dispatch(actions.user.changeToken({ token: res.data.accessToken }));
      }
    } catch (err: any) {
      console.log(err);
      const errMsg = errorHandler(err);
      error(errMsg);
    }
  };

  // Claude: keep latest token in a ref so the interval always uses the current value 30-04-2026
  const tokenRef = React.useRef(user?.token);
  useEffect(() => { tokenRef.current = user?.token; }, [user?.token]);

  // Claude: silent token refresh — run once on mount, then every 50 min (JWT expiry is 1hr) 30-04-2026
  // Previously used [user] dependency which caused an infinite refresh loop on every changeToken dispatch.
  useEffect(() => {
    if (!tokenRef.current) return;
    refreshToken(tokenRef.current);
    const id = setInterval(() => {
      if (tokenRef.current) refreshToken(tokenRef.current);
    }, 50 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  // Claude: set browser tab title based on current route 23-02-2026
  useEffect(() => {
    // Handle dynamic paths like /buyer/redemption/:id and /create-password/:token
    const path = location.pathname;
    const staticTitle = PAGE_TITLES[path];
    if (staticTitle) {
      document.title = staticTitle;
    } else if (path.startsWith("/buyer/redemption/")) {
      document.title = "AFTR | Redemption";
    } else if (path.startsWith("/create-password/")) {
      document.title = "AFTR | Create Password";
    } else {
      document.title = "AFTR";
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {/* Admin Pages */}

      <Route
        path="/admin"
        element={<AdminLayout children={<AdminDashboard />} />}
      />
      <Route path="/admin/login" element={<AdminLogin />} />
<Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
      <Route
        path="/admin/organizer"
        element={<AdminLayout children={<AdminOrganiser />} />}
      />
      {/* Claude: subscription plans decoupled from events — standalone page 19-02-2026 */}
      <Route
        path="/admin/seller-subscriptions"
        element={<AdminLayout children={<AdminSubscriptions />} />}
      />
      {/* Claude: buyer subscription plans — 11-Apr-2026 */}
      <Route
        path="/admin/buyer-subscriptions"
        element={<AdminLayout children={<AdminBuyerSubscriptions />} />}
      />
      {/* Claude: industry tree admin page 27-02-2026 */}
      <Route
        path="/admin/industry"
        element={<AdminLayout children={<AdminIndustry />} />}
      />
      {/* Claude: flat department list admin page 16-Apr-2026 */}
      <Route
        path="/admin/departments"
        element={<AdminLayout children={<AdminDepartments />} />}
      />
      {/* Claude: industry stats page 13-03-2026 */}
      <Route
        path="/admin/industry-stats"
        element={<AdminLayout children={<AdminIndustryStats />} />}
      />
      {/* Claude: department stats page 18-04-2026 */}
      <Route
        path="/admin/department-stats"
        element={<AdminLayout children={<AdminDepartmentStats />} />}
      />
      {/* Claude: tags list page 04-05-2026 */}
      <Route
        path="/admin/tags-list"
        element={<AdminLayout children={<AdminTagsList />} />}
      />
      {/* Claude: reward plans admin page 27-02-2026 */}
      <Route
        path="/admin/reward-plans"
        element={<AdminLayout children={<AdminRewardPlans />} />}
      />
      <Route
        path="/admin/events"
        element={<AdminLayout children={<AdminEvents />} />}
      />
      <Route
        path="/admin/sellers"
        element={<AdminLayout children={<AdminSellers />} />}
      />
      {/* Claude: add/edit seller as full page — replaced modal 25-Apr-2026 */}
      <Route path="/admin/sellers/new" element={<AdminLayout children={<SellerEditPage />} />} />
      <Route path="/admin/sellers/:sellerId/edit" element={<AdminLayout children={<SellerEditPage />} />} />

      <Route
        path="/admin/buyers"
        element={<AdminLayout children={<AdminBuyers />} />}
      />
      {/* Claude: add/edit buyer as full page — replaced modal 25-Apr-2026 */}
      <Route path="/admin/buyers/new" element={<AdminLayout children={<BuyerEditPage />} />} />
      <Route path="/admin/buyers/:buyerId/edit" element={<AdminLayout children={<BuyerEditPage />} />} />

      <Route
        path="/admin/buyer-rewards"
        element={<AdminLayout children={<BuyerRewards />} />}
      />
      {/* Claude: A1 — upload reports page 26-02-2026 */}
      <Route
        path="/admin/upload-reports"
        element={<AdminLayout children={<AdminUploadReports />} />}
      />
      {/* Claude: Stats page 27-02-2026 */}
      <Route
        path="/admin/stats"
        element={<AdminLayout children={<AdminStats />} />}
      />
      {/* Claude: Companies aggregated view 01-03-2026 */}
      <Route
        path="/admin/companies"
        element={<AdminLayout children={<AdminCompanies />} />}
      />
      {/* Claude: Admin Users — change password + create admin 02-03-2026 */}
      <Route
        path="/admin/admin-users"
        element={<AdminLayout children={<AdminUsers />} />}
      />
      {/* Claude: Content — Buyer FAQ, Seller FAQ, AI KB Buyers, AI KB Sellers 15-03-2026 */}
      <Route path="/admin/buyer-faq" element={<AdminLayout children={<AdminBuyerFAQ />} />} />
      <Route path="/admin/seller-faq" element={<AdminLayout children={<AdminSellerFAQ />} />} />
      <Route path="/admin/ai-knowledge-common" element={<AdminLayout children={<AdminAIKnowledgeCommon />} />} />
      <Route path="/admin/ai-knowledge-buyers" element={<AdminLayout children={<AdminAIKnowledgeBuyers />} />} />
      <Route path="/admin/ai-knowledge-sellers" element={<AdminLayout children={<AdminAIKnowledgeSellers />} />} />
      {/* Claude: Feedback pages — seller and buyer 26-03-2026 */}
      <Route path="/admin/seller-feedback" element={<AdminLayout children={<AdminSellerFeedback />} />} />
      <Route path="/admin/buyer-feedback" element={<AdminLayout children={<AdminBuyerFeedback />} />} />

      {/* Common */}
      {/* Claude: Login is full-page (includes banner + role radio) — no MobileLayout wrapper 05-03-2026 */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<NewUserRegistration />} /> {/* Claude: N25 — self-registration 05-03-2026 */}
      <Route
        path="/forgot-password"
        element={<MobileLayout children={<ForgotPassword />} />}
      />
      <Route
        path="/create-password/:token"
        element={<MobileLayout children={<CreatePassword />} />}
      />
      <Route
        path="/reset-password"
        element={<MobileLayout children={<ResetPassword />} />}
      />
      <Route
        path="/relevance"
        element={<MobileLayout children={<Relevance />} />}
      />
      <Route
        path="/notification"
        element={<MobileLayout children={<Notifications />} />}
      />
      <Route
        path="/profile"
        element={<MobileLayout children={<Profile />} />}
      />
      <Route
        path="/meet"
        element={<MobileLayout children={<CreateMeeting />} />}
      />
      {/* <Route
        path="/meetings"
        element={<MobileLayout children={<MeetingList />} />}
      /> */}

      {/* ORGANIZER */}

      <Route
        path="/organizer"
        element={<OrganizerLayout children={<OrganizerHome />} />}
      />

      <Route
        path="/organizer/company"
        element={<OrganizerLayout children={<Company />} />}
      />

      <Route
        path="/organizer/chat"
        element={<OrganizerLayout children={<Chat />} />}
      />

      <Route
        path="/organizer/myaccount"
        element={<OrganizerLayout children={<Account />} />}
      />

      <Route
        path="/organizer/notifications"
        element={<OrganizerLayout children={<Notification />} />}
      />

      {/* Seller */}
      {/* Claude: N47 — /seller/ai route removed; AI Chat accessible via drawer only 26-03-2026 */}
      <Route
        path="/seller"
        element={<SellerLayout children={<SellerDashboard />} />}
      />
      <Route
        path="/seller/list"
        element={<SellerLayout children={<BuyersList />} />}
      />
      <Route
        path="/seller/calendar"
        element={<SellerLayout children={<MeetingList />} />}
      />
      <Route
        path="/seller/profile"
        element={<SellerLayout children={<SellerProfile />} />}
      />
      <Route
        path="/seller/visibility"
        element={<SellerLayout children={<ProfileVisibility />} />}
      />
      <Route
        path="/seller/chat"
        element={<SellerLayout children={<SellerChat />} />}
      />
      <Route
        path="/seller/notifications"
        element={<SellerLayout children={<Notification />} />}
      />
      <Route
        path="/seller/company"
        element={<SellerLayout children={<SellerCompany />} />}
      />
      <Route
        path="/seller/myaccount"
        element={<SellerLayout children={<SellerAccount />} />}
      />
      <Route
        //path="/seller/pas"
        path="/seller/catalog"
        element={<SellerLayout children={<SellerCatalog />} />}
      />
      <Route
        path="/seller/announcements"
        element={<SellerLayout children={<SellerAnnouncements />} />}
      />
      <Route
        path="/seller/seller-subscriptions"
        element={<SellerLayout children={<Subscription />} />}
      />
      <Route
        path="/seller/seller-subscriptions-cart"
        element={<SellerLayout children={<SubscriptionCart />} />}
      />
      <Route
        path="/seller/seller-subscriptions-purchase"
        element={<SellerLayout children={<SubscriptionPurchase />} />}
      />
      <Route
        path="/seller/seller-subscriptions-statements"
        element={<SellerLayout children={<SubscriptionStatement />} />}
      />

      {/* Buyer */}
      {/* Claude: Added AI Chat route as buyer landing page 16-02-2026 */}
      <Route
        path="/buyer/ai"
        element={<BuyerLayout children={<AiChat />} />}
      />
      <Route
        path="/buyer"
        element={<BuyerLayout children={<BuyerDashboard />} />}
      />
      <Route
        path="/buyer/calendar"
        element={<BuyerLayout children={<MeetingList />} />}
      />
      <Route
        path="/buyer/list"
        element={<BuyerLayout children={<BuyerHome />} />}
      />
      <Route
        path="/buyer/profile"
        element={<BuyerLayout children={<BuyerProfile />} />}
      />
      <Route
        path="/buyer/chat"
        element={<BuyerLayout children={<BuyerChat />} />}
      />
      <Route
        path="/buyer/notifications"
        element={<BuyerLayout children={<Notification />} />}
      />
      <Route
        path="/buyer/company"
        element={<BuyerLayout children={<BuyerCompany />} />}
      />
      <Route
        path="/buyer/myaccount"
        element={<BuyerLayout children={<BuyerAccount />} />}
      />
      <Route
        path="/buyer/rfp"
        element={<BuyerLayout children={<BuyerRFP />} />}
      />
      <Route
        path="/buyer/scan"
        element={<BuyerLayout children={<Qrscan />} />}
      />
      <Route
        path="/buyer/rewards"
        element={<BuyerLayout children={<Rewards />} />}
      />
      <Route
        path="/buyer/rewards-statement"
        element={<BuyerLayout children={<RewardsStatement />} />}
      />
      <Route
        path="/buyer/redemption-verification"
        element={<BuyerLayout children={<RedemptionVerification />} />}
      />
      <Route
        path="/buyer/redemption/:redemptionId" 
        element={<BuyerLayout children={<Redemption />} />}
      />
      {/* Claude: N47 — /buyer/feeds reinstated as standalone route 26-03-2026 */}
      <Route path="/buyer/feeds" element={<BuyerLayout children={<BuyerFeeds />} />} />
      {/* Claude: /buyer/discover route removed — Keyword Search merged into /buyer/rfxs 10-03-2026 */}
      {/* Claude: buyer digital assets 25-02-2026 */}
      <Route path="/buyer/catalog" element={<BuyerLayout children={<BuyerCatalog />} />} />
      {/* Claude: buyer subscription plan page 11-Apr-2026 */}
      <Route path="/buyer/subscription" element={<BuyerLayout children={<BuyerSubscription />} />} />
      {/* Claude: RFX pages 24-02-2026 */}
      <Route path="/buyer/rfxs" element={<BuyerLayout children={<Discover />} />} />
      <Route path="/seller/rfxs" element={<SellerLayout children={<SellerRFXList />} />} />
      <Route path="/seller/rfx-detail" element={<SellerLayout children={<SellerRFXDetail />} />} />

    </Routes>
  );
};

export default Router;
